import React, { useCallback, useEffect } from "react";
import { YouTubePlayer } from "react-youtube";
import { ExpressionType, ActivityBlockConfigData, ChatConfigData } from "../Shared/Party/PartyConfigData";
import { TitleBar, TitleBarProps } from "./TitleBar"
import { CreateFanboxMediaList, FanboxMediaList, YouTubePanel } from "./YouTubePanel";
import { ReplyPanel, ReplyPanelProps } from "./ReplyPanel";
import { LandingPage, LandingPageProps } from "./LandingPage";
import { StateManagerContext } from "./StateManagerContext";
import { StateManager } from "./PartyState";
import { ContentContextData } from "../Shared/Party/ContentContext";
import { ProfileDisplay, ProfileDisplayProps } from "./ProfileDisplay";
import { ActivityDisplay } from "./ActivityDisplay";
import { MessagePositionFunction, UIConfig, UIConfigContext, UserMessageHandler } from "./UIConfigContext";
import { MainPartyView } from "./MainPartyView";
import { UserActionDisplay } from "./UserActionDisplay";
import { UserMessageDisplay, UserMessageDisplayProps } from "./UserMessageDisplay";
import { PurchaseBoosts, PurchaseBoostsProps } from "./PurchaseBoosts";
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import HomeIcon from '@mui/icons-material/Home';
import { CurrencyExchange, Feed } from "@mui/icons-material";
import { useGoogleOneTapLogin } from "@react-oauth/google";
import { GoogleLoginHandler } from "../User/CommonAuth";
import { CreateTextLayoutEngine } from "./TextLayoutEngine";



export type EventDrivenOverlayViewSubmitHandler = (data: { [key: string]: string }) => void;

export type EventDrivenOverlayViewEvent = 'reply' | 'signIn' | 'showProfile';

export type EventDrivenOverlayView = {
  name: EventDrivenOverlayViewEvent;
  create: (submit: EventDrivenOverlayViewSubmitHandler, cancel: () => void, height: number, data: { [key: string]: string }) => JSX.Element;
}

const eventDrivenOverlayViews: Map<EventDrivenOverlayViewEvent, EventDrivenOverlayView> = new Map();

eventDrivenOverlayViews.set('reply', {
  name: "reply",
  create: (submit, cancel, height): JSX.Element => {
    const props: ReplyPanelProps = {
      height: height,
      replyCallback: (expression, message, boosts) => {
        const data: { [key: string]: string } = {
          expression: expression,
          message: JSON.stringify(message),
          boosts: boosts + ''
        }
        submit(data);
      },
      cancelCallback: cancel

    }
    return <ReplyPanel {...props} />

  }
});

eventDrivenOverlayViews.set("signIn", {
  name: 'signIn',
  create: (_submit, cancel, height): JSX.Element => {
    /*const props: SignInPanelProps = {
      alreadySignedIn: cancel,
      height: height
    }*/

    return <div></div>
  }
});
eventDrivenOverlayViews.set("showProfile", {
  name: 'showProfile',
  create: (_submit, cancel, height, data): JSX.Element => {

    const props: ProfileDisplayProps = {
      height: height,
      nickname: data['nickname']
    }

    return <ProfileDisplay {...props} />
  }
});


export type MenuOverlayName = 'home' | 'actions' | 'messages' | 'purchase';

export type MenuOverlayView = {
  name: MenuOverlayName;
  create: (backToHome: () => void) => JSX.Element;
  icon: (size: number, onClick: () => void, key: string, selected: boolean, uiConfig: UIConfig) => JSX.Element;
}

const wrapImage = (url: string, size: number, onClick: () => void, key: string, selected: boolean) => {
  return <div
    style={{
      backgroundImage: 'url(' + url + (selected ? '_select' : '') + ')',
      backgroundSize: 'contain',
      maxHeight: size,
      minHeight: size,
      height: size,
      minWidth: size,
      width: size,
      maxWidth: size
    }} onClick={() => { onClick(); }} key={key}></div>
}

const menuOverlayView: MenuOverlayView[] = [

  {
    name: 'home',
    create: (_backToHome: () => void) => { return <div></div> },
    icon: (size: number, onClick: () => void, key: string, selected: boolean, uiConfig: UIConfig) => {

      /*const icon : Icon = <HomeIcon/>;
      icon.props.sx = { maxHeight: size, minHeight: size, height: size, marginLeft : '20px' , color : (selected ? uiConfig.fanboxColor('darkPink') : 'white') };
      icon.props.onClick = () => { onClick(); }
      icon.props.key = key;*/

      return <div style={{ backgroundColor: selected ? 'white' : uiConfig.fanboxColor('darkPink'), marginLeft: '20px' }} key={key}>
        <HomeIcon sx={{ maxHeight: size, minHeight: size, height: size, color: (selected ? uiConfig.fanboxColor('darkPink') : 'white') }} onClick={() => { onClick(); }} />

      </div>
    } //{ return wrapImage('/images/fbLogo-small.png', size, onClick, key); }
  },
  {
    name: 'actions',
    create: (_backToHome: () => void): JSX.Element => {
      return <UserActionDisplay />;
    },
    icon: (size: number, onClick: () => void, key: string, selected: boolean, uiConfig: UIConfig) => {
      return <div style={{ backgroundColor: selected ? 'white' : uiConfig.fanboxColor('darkPink'), marginLeft: '20px' }} key={key}>
        <ManageHistoryIcon style={{ maxHeight: size, minHeight: size, height: size, color: (selected ? uiConfig.fanboxColor('darkPink') : 'white') }} onClick={() => { onClick(); }} />
      </div>
    }
  },
  {
    name: 'messages',
    create: (_backToHome: () => void): JSX.Element => {
      return <UserMessageDisplay />
    },
    icon: (size: number, onClick: () => void, key: string, selected: boolean, uiConfig: UIConfig) => {
      return <div style={{ backgroundColor: selected ? 'white' : uiConfig.fanboxColor('darkPink'), marginLeft: '20px' }} key={key}>
        <Feed style={{ maxHeight: size, minHeight: size, height: size, color: (selected ? uiConfig.fanboxColor('darkPink') : 'white') }} onClick={() => { onClick(); }} />
      </div>
    }
  },
  {
    name: 'purchase',
    create: (backToHome: () => void): JSX.Element => {
      return <PurchaseBoosts backToHome={backToHome} />
    },
    icon: (size: number, onClick: () => void, key: string, selected: boolean, uiConfig: UIConfig) => {
      return <div style={{ backgroundColor: selected ? 'white' : uiConfig.fanboxColor('darkPink'), marginLeft: '20px' }} key={key}>
        <CurrencyExchange style={{ maxHeight: size, minHeight: size, height: size, color: (selected ? uiConfig.fanboxColor('darkPink') : 'white') }} onClick={() => { onClick(); }} />
      </div>
    }
  }

]


const initUIConfig = (uiConfig: UIConfig) => {
  uiConfig.fontBase = uiConfig.height < 810 ? 14 : 16;
  uiConfig.titleHeight = 2 * uiConfig.fontBase;
  uiConfig.videoHeight = 200;
  uiConfig.videoWidth = 356;
  uiConfig.contolBackground = '#303030'
  return true;
}

type selectFunc = (index: number) => void;

export const Party = () => {

  const stateManager = React.useContext(StateManagerContext);
  const uiConfig = React.useContext(UIConfigContext);
  const _initFlag = React.useRef<boolean>(initUIConfig(uiConfig));
  const titleSelect = React.useRef<selectFunc | null>(null);
  const inDev = window.location.toString().includes('/dev');

  useGoogleOneTapLogin({
    onSuccess: (credentials) => { GoogleLoginHandler(credentials, stateManager); },
    onError: () => {
      console.log('Login Failed');
    },
  });


  const setTitleSelect = (f: (index: number) => void) => {
    titleSelect.current = f;
  }

  const height = uiConfig.height;


  //const [selectedComponent, setSelectedComponent] = React.useState("");
  const [uiStatus, setUIStatus] = React.useState<number>(0);

  const replyChatIdRef = React.useRef<string>('');
  const replyMessagePositionFunction = React.useRef<MessagePositionFunction | null>(null);



  const [showEventOverlay, setShowEventOverlay] = React.useState<boolean>(false);
  const eventOverlayRef = React.useRef<JSX.Element | null>(null);


  const ShowEventOverlay = (eventType: EventDrivenOverlayViewEvent, data: { [key: string]: string }) => {
    const eoRow = eventDrivenOverlayViews.get(eventType);
    if (eoRow !== undefined) {
      if (eventType === 'reply')
        replyChatIdRef.current = data['id'];
      eventOverlayRef.current = eoRow.create(eventType === 'reply' ? (data) => {
        const handler = uiConfig.getUserMessageHandler();
        if (handler !== null) {
          var messagePosition = 1000;
          if (replyMessagePositionFunction.current !== null)
            messagePosition = replyMessagePositionFunction.current().next;
          const userMessage = stateManager.addUserMessage(replyChatIdRef.current, data['message'], data['expression'] as ExpressionType, Number.parseInt(data['boosts']), messagePosition);
          handler(userMessage);
          closeEventOverlay();
        }
      } : (_data) => { closeEventOverlay(); }, closeEventOverlay, uiConfig.height - 30, data);

      setShowEventOverlay(true);
      const panel = document.getElementById("eventOverlayDisplay");
      if (panel !== null) {
        panel.style.top = '0px';
      }

    }

  }

  uiConfig.showEventOverlay = ShowEventOverlay;



  const closeEventOverlay = () => {
    const panel = document.getElementById("eventOverlayDisplay");
    if (panel !== null) {
      panel.style.top = height + 'px';
    }
    window.setTimeout(
      () => {
        setShowEventOverlay(false);
        eventOverlayRef.current = null;
      },
      1000);
  }

  useEffect(() => {
    uiConfig.textLayout = CreateTextLayoutEngine("TextSizingTesterDiv", "TextSizingTesterSpan")
  }, [])



  const TitleBarClick = (index: number) => {
    setUIStatus(index);
  }

  const backToHome = () => {
    if (titleSelect.current !== null)
      titleSelect.current(0);
    setUIStatus(0);
  }

  const setTitleBarOption = (id: MenuOverlayName) => {
    var sel = -1;
    for (let i = 0; i < menuOverlayView.length; i++) {
      if (menuOverlayView[i].name === id) {
        sel = i;
        i = menuOverlayView.length;
      }
    }
    if (sel >= 0) {
      if (titleSelect.current !== null)
        titleSelect.current(sel);
      setUIStatus(sel);
    }
  }

  uiConfig.showMenuItem = setTitleBarOption;



  const titleBarProps: TitleBarProps = {
    count: stateManager.userMessages().totalLikes(),
    onDesktop: false,
    clickOn: TitleBarClick,
    menuItems: menuOverlayView,
    selectSetter: setTitleSelect
  }

  return (
    <div className="scrollablePanel"
      style={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "black",
        position: "relative",
        height: uiConfig.height,
        width: uiConfig.width,
        minHeight: uiConfig.height,
        maxHeight: uiConfig.height,
        minWidth: uiConfig.width,
        maxWidth: uiConfig.width,
        overflow: 'clip'
      }}
    >
      <div style={{ position: 'absolute', visibility: 'hidden', fontFamily: 'roboto', fontWeight: 400, fontSize: '16px' }} id="TextSizingTesterDiv"><span id="TextSizingTesterSpan">This is a much longer piece of text which should be at least twice as wide or high or whatever it is that is being measured</span></div>
      <TitleBar {...titleBarProps} />
      <MainPartyView />
      <div id='eventOverlayDisplay' style={{ opacity: 1.0, transition: 'top 1s', transitionTimingFunction: 'ease-in-out', position: 'absolute', top: height + 'px' }}>
        {(showEventOverlay && eventOverlayRef.current !== null) &&
          <div style={{ display: 'flex', flexDirection: 'column', position: 'static' }}>
            <div style={{ backgroundColor: '#92007f', minHeight: '30px', maxHeight: '30px', display: 'flex', justifyContent: 'right' }} onClick={() => { closeEventOverlay(); }}><img src='/images/white-close-tranparent30.png' /></div>
            {eventOverlayRef.current}
          </div>}
      </div>

      <div style={{ position: 'absolute', top: uiConfig.titleHeight + 'px' }} >
        {menuOverlayView[uiStatus].create(backToHome)}
      </div>

    </div>

  );


};
